<div
  class="flex flex-row items-center justify-start gap-2"
  [ngClass]="{
    warn:
      !passwordFormControl.pristine &&
      passwordFormControl.errors != null &&
      passwordFormControl.errors[errorFieldName],
    success: passwordFormControl.errors == null || !passwordFormControl.errors[errorFieldName]
  }"
>
  <div *ngIf="passwordFormControl.pristine; then pristine; else dirty"></div>
  <ng-template #pristine><div class="pristine-container"></div></ng-template>
  <ng-template #dirty
    ><ng-template
      *ngIf="
        passwordFormControl.errors != null && passwordFormControl.errors[errorFieldName];
        then fail;
        else pass
      "
    ></ng-template
  ></ng-template>
  <ng-template #fail
    ><mat-icon aria-label="Requirement failed" i18n-aria-label>close</mat-icon></ng-template
  >
  <ng-template #pass
    ><mat-icon aria-label="Requirement passed" i18n-aria-label>done</mat-icon></ng-template
  >
  <div class="requirement-text">{{ requirementText }}</div>
</div>
